import { useEffect, useState } from "react";

export function useLoad<T>(fn: () => Promise<T>): T | null {
  const [v, setV] = useState<T | null>(null);

  useEffect(() => {
    fn().then(setV);
  }, []);

  return v;
}
